import { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Card } from 'react-bootstrap';
import { IndexNowService, type IndexNowStatus } from '../../../services/IndexNowService';
export default function IndexNowSettings({ siteId }: { siteId: string }) {
  const service = useMemo(() => new IndexNowService(), []);
  const [status, setStatus] = useState<IndexNowStatus | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  useEffect(() => {
    let active = true;
    setStatus(null); setError(''); setNotice('');
    service.status(siteId).then(value => { if (active) { if (value) setStatus(value); else setError("IndexNow status could not be loaded, or you do not have permission to manage it."); } }).catch(() => { if (active) setError('IndexNow status could not be loaded, or you do not have permission to manage it.'); });
    return () => { active = false; };
  }, [siteId, service]);
  async function refresh() {
    setBusy(true); setError('');
    try { const value = await service.status(siteId); if (!value) throw new Error(); setStatus(value); }
    catch { setError('IndexNow status could not be loaded. Please retry.'); }
    finally { setBusy(false); }
  }
  async function submit() {
    setBusy(true); setError(''); setNotice('');
    try {
      const result = await service.submitPublished(siteId);
      if (!result) throw new Error();
      setNotice(`${result.PageCount} published page(s) queued for notification.`);
      setStatus(await service.status(siteId));
    } catch { setError('Published pages could not be submitted. Please retry.'); }
    finally { setBusy(false); }
  }
  return <Card className="mt-4"><Card.Body>
    <h2 className="h5">Search engine notifications</h2>
    <p>IndexNow tells supported search engines when your published pages change. Each search engine decides whether and when to index them.</p>
    {error && <Alert variant="danger">{error}</Alert>}
    {notice && <Alert variant="success">{notice}</Alert>}
    {status && <><p>{status.Enabled ? 'IndexNow is enabled.' : 'IndexNow is not enabled for this service.'}</p>
      <p>Pending: {status.Pending} · Failed: {status.Failed}</p>
      <p>Last accepted notification: {status.LastAcceptedUtc ? new Date(status.LastAcceptedUtc).toLocaleString() : 'None yet'}</p></>}
    <div className="d-flex gap-2"><Button variant="outline-secondary" disabled={busy} onClick={() => void refresh()}>Refresh status</Button>
      <Button disabled={busy || !status?.Enabled || !!status.Pending} onClick={() => void submit()}>Notify search engines about published pages</Button></div>
  </Card.Body></Card>;
}
